import { memo, useMemo } from 'react';
import { Heading, Link } from '@appsumo/dorado-react';

import { capitalizeFirstCharacter } from '~/lib/util';
import type { FTFCompanyDetailsProps } from '~/types/product';
import FTFCompanyDetailItem from './FTFCompanyDetailItem';

export default memo(function FTFCompanyDetails({
  companyName,
  companyUrl,
  items,
}: Readonly<FTFCompanyDetailsProps>) {
  const url = useMemo(() => {
    if (!companyUrl) return null;

    const url = companyUrl
      .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
      .split('/')[0];

    return {
      label: capitalizeFirstCharacter(url),
      value: companyUrl,
    };
  }, [companyUrl]);

  return (
    <div
      className="flex flex-col gap-6 grid-in-founder"
      data-testid="ftf-company-details"
    >
      <div className="flex flex-col">
        <Heading.H3 className="text-[22px] md:text-2xl">
          {companyName}
        </Heading.H3>
        {url && (
          <Link href={url.value} className="text-bolt" styled target="_blank">
            {url.label}
          </Link>
        )}
      </div>
      <div className="flex flex-col">
        {items.map((item) => (
          <FTFCompanyDetailItem key={item.label} item={item} />
        ))}
      </div>
    </div>
  );
});
